import React from "react";
import {NextPage} from 'next';
import HtmlHead from "../src/components/headerAndFooter/HtmlHead";
import WaveLayout from "../src/layouts/WaweLayout";
import * as styled from "../src/components/subpageHeroArea/ApplicationSubpageStyled";
import GeneralFormComp from "../src/components/generalForm/GeneralFormComp";
import ScrollButton from "../src/components/buttons/scrollButton/ScrollButton";
import Image from "next/image";
import {NavigationURLs} from "../src/functions/NavigationFunctions";

const HappyCouplesTop = () => {
    return (
        <React.Fragment>
            <styled.HappyCouplesTopWrapper>
                <styled.CareerApplicationImageContentTitle>
                    binlerce mutlu çiftimiz var
                </styled.CareerApplicationImageContentTitle>
                <styled.CareerApplicationImageContentText>
                    Evlilik düşünen üyelere hizmet eden sitemizde bugüne kadar pek çok çiftimiz tanışmış, mutlu bir
                    beraberliğe adım atmış ve evlenmiştir.
                </styled.CareerApplicationImageContentText>
                <ScrollButton>
                    Hikayeni gönder
                </ScrollButton>
                <styled.CareerApplicationImageContentText className={'mobile-hidden'}>
                    İstanbul'dan Melike Hanım ve İzmit’ten Hakan Bey Pembe Panjur’da tanışıp evlendiler. Melike Hanım'ın
                    bize mesajından ufak bir alıntı:
                </styled.CareerApplicationImageContentText>
                <styled.CareerApplicationImageContentText className={'mobile-hidden'}>
                    "Mutluluğu yakalamak uzun sürmedi, üye oldum, bir gün sonra hayatımın anlamı paşamı buldum rüya gibiydi
                    ama gerçek oldu :)"
                </styled.CareerApplicationImageContentText>
            </styled.HappyCouplesTopWrapper>
        </React.Fragment>
    );
}

const HappyCouplesForm = () => {
    return (
        <React.Fragment>
            {/*<styled.CareerApplicationImageContentText className={'text-black desktop-hidden'}>*/}
            {/*    Öte yandan bazı çiftlerimiz diğer üyelerimize ilham olmak için hikayelerini bizimle paylaştı ve biz de*/}
            {/*    Pembe Panjur ekibi olarak mutlu günlerinde onların yanında olduk ve hediyelerimizle yuvalarına katkıda*/}
            {/*    bulunduk. Bundan sonra da aynı şekilde, istikrarla onların sevincini paylaşmaya devam edeceğiz.*/}
            {/*    Hikayelerini yayınlama izni veren çiftlerimize alyanslarını biz hediye edeceğiz. Çiftlerimize ayrıca*/}
            {/*    sürpriz hediyelerimiz de olacak.*/}
            {/*</styled.CareerApplicationImageContentText>*/}
            {/*<styled.CareerApplicationImage />*/}
            <styled.CareerApplicationImageContentText className={'text-black'}>
                İstanbul'dan Melike Hanım ile İzmit’ten Hakan Bey de bu çiftlerden biriydi. Pembe Panjur’da tanışıp
                evlenmekten çok mutlu olduğunu ifade eden Melike Hanım bize gönderdiği mesajda şunları söyledi:
            </styled.CareerApplicationImageContentText>
            <styled.CareerApplicationImageContentText className={'text-black'}>
                "Bizim için mutluluğu yakalamak çok uzun sürmedi. Üye olduktan bir gün sonra hayatımın anlamı paşamı
                buldum, rüya gibiydi ama gerçek oldu."
            </styled.CareerApplicationImageContentText>
            <styled.CareerApplicationImageContentText className={'text-black'}>
                Eğer siz de hikayenizi bizimle paylaşıp mutluluğunuza ortak olmamızı istiyorsanız aşağıdaki formu
                doldurmanız yeterli. En kısa zamanda sizinle iletişime geçilecektir.
            </styled.CareerApplicationImageContentText>
        </React.Fragment>
    );
}

const BasariHikayeleriGonder: NextPage = () => {
    const breadcrumbItemsBasariHikayeleriGonder = [
        { label: 'Pembe Panjur', link: NavigationURLs.landing },
        { label: 'Hikayeni Gönder'}
    ];
    return (
        <React.Fragment>
            <HtmlHead pageTitle="Basari Hikayeleri Gonder" description={'Pembe Panjur başarı hikayeleri gönderme ile ilgili detaylara sayfamızdan ulaşabilirsiniz.'}/>
            <WaveLayout
                backgroundColor={'linear-gradient(180deg, #D2147D 0%, #752280 100%)'}
                loginButtonText={false}
                homeButton={true}
                extraChildren={
                    <React.Fragment>
                        <styled.ApplicationSubpage>
                            <styled.ApplicationSubpageContainer>
                                <styled.ApplicationSubpageWrapper>
                                    <styled.ApplicationSubpageImage>
                                        <styled.CareerApplicationImageContent>
                                            <HappyCouplesTop/>
                                        </styled.CareerApplicationImageContent>
                                    </styled.ApplicationSubpageImage>
                                    <GeneralFormComp title={'Hikayeni gönder'} content={true}
                                                     textareaTitle={'Hikayeniz'}
                                                     textareaPlaceholder={'Tanışma hikayenizi buraya yazabilirsiniz.'}
                                                     careerUpload={false}
                                                     breadcrumb={breadcrumbItemsBasariHikayeleriGonder}
                                    >
                                        <HappyCouplesForm/>
                                    </GeneralFormComp>
                                </styled.ApplicationSubpageWrapper>
                            </styled.ApplicationSubpageContainer>
                        </styled.ApplicationSubpage>
                    </React.Fragment>
                }
            >
                <styled.CareerApplicationMobileHeroArea>
                    <Image loading={'lazy'} width={733}
                           height={293}
                           sizes={'100vw'}
                           style={{width: '100%', height: 'auto'}}
                           src={`/next/assets/images/basari_hikayeleri/hikaye-gonder-mobile-img-1.png`}
                           alt={'Pembe Panjur Basari Hikayeleri'} title={'Pembe Panjur Basari Hikayeleri'}
                           />
                    <HappyCouplesTop/>
                </styled.CareerApplicationMobileHeroArea>
            </WaveLayout>
        </React.Fragment>
    );
}

import { checkAuthAndRedirect } from '../src/utils/authHelper';

export const getServerSideProps = async (context: any) => {
    return await checkAuthAndRedirect(context);
};


export default BasariHikayeleriGonder;
